
const getFormatCurrency = (mount, currency) => {
    return currency + mount.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
}

const getCurrency = (mount) => {
    return mount.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
}

export { getFormatCurrency, getCurrency }